"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var value_checker_1 = __importDefault(require("./value_checker"));
var PriceUtils = /** @class */ (function () {
    function PriceUtils() {
    }
    PriceUtils.getPriceStr = function (value) {
        if (value_checker_1.default.isBlank(value)) {
            return '';
        }
        var number = Number(value);
        if (isNaN(number)) {
            number = 0;
        }
        return "\uFFE5" + number.toLocaleString();
    };
    return PriceUtils;
}());
exports.default = PriceUtils;



//////////////////
// WEBPACK FOOTER
// ./common/src/utils/validation/price_utils.ts
// module id = P7MZ
// module chunks = 1